import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SR_API_ACTION_MEDIA_DELETE } from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrTable from 'client/components/SrTable';
import SrUpsertMediaModal from 'client/components/SrUpsertMediaModal';

class SrAdminMediaListTable extends Component {
  static propTypes = {
    mediaList: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    reloadMediaList: PropTypes.func,
    createMediaDefaultValues: PropTypes.object.isRequired,
    createMediaTitle: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      updateModalMedia: null,
      createModalIsOpen: false,
    };
  }

  _onDeleteMediaClick = (media) => {
    const { reloadMediaList, dispatch } = this.props;
    if (!global.confirm(`Are you sure you want to delete media "${media.title}"?`)) {
      return;
    }
    dispatch(postWithState, {
      action: SR_API_ACTION_MEDIA_DELETE,
      payload: {
        id: media.id,
      },
    }).then(() => {
      if (reloadMediaList) {
        reloadMediaList();
      }
    });
  };

  _onCreateMediaClick = () => {
    this.setState({
      updateModalMedia: null,
      createModalIsOpen: true,
    });
  };

  _onUpdateMediaClick = (media) => {
    this.setState({
      updateModalMedia: media,
      createModalIsOpen: false,
    });
  };

  _onMediaUpdated = () => {
    const { reloadMediaList } = this.props;
    if (reloadMediaList) {
      reloadMediaList();
    }
    this._onMediaModalClose();
  };

  _onMediaModalClose = () => {
    this.setState({
      updateModalMedia: null,
      createModalIsOpen: false,
    });
  };

  render() {
    const { mediaList, createMediaDefaultValues, createMediaTitle } = this.props;

    const { updateModalMedia, createModalIsOpen } = this.state;

    return (
      <div>
        <SrText cursor="pointer" color="blue300" onClick={this._onCreateMediaClick}>
          Add 3D Tour or Video
        </SrText>
        <SrTable
          headers={[
            { content: 'id' },
            { content: 'type' },
            { content: 'url' },
            { content: 'title' },
            { content: 'description' },
            { content: 'actions' },
          ]}
          rows={mediaList.map((media) => ({
            cells: [
              { content: media.id },
              { content: media.type },
              { content: media.url },
              { content: media.title },
              { content: media.description },
              {
                content: (
                  <SrBox>
                    <SrText
                      cursor="pointer"
                      color="blue300"
                      onClick={() => this._onUpdateMediaClick(media)}
                    >
                      Edit
                    </SrText>
                    <SrText
                      cursor="pointer"
                      color="blue300"
                      onClick={() => this._onDeleteMediaClick(media)}
                    >
                      Delete
                    </SrText>
                  </SrBox>
                ),
              },
            ],
          }))}
        />
        {updateModalMedia && (
          <SrUpsertMediaModal
            title={createMediaTitle}
            defaultValues={updateModalMedia}
            onSuccess={this._onMediaUpdated}
            onClose={this._onMediaModalClose}
          />
        )}
        {createModalIsOpen && (
          <SrUpsertMediaModal
            title={createMediaTitle}
            defaultValues={createMediaDefaultValues}
            onSuccess={this._onMediaUpdated}
            onClose={this._onMediaModalClose}
          />
        )}
      </div>
    );
  }
}

SrAdminMediaListTable.displayName = 'SrAdminMediaListTable';

export default SrAdminMediaListTable;
